import { FieldValues, useController, UseControllerProps } from 'react-hook-form';

import { IOptionType } from 'interfaces/forms';

import { ChipSelector } from '../ChipSelector/ChipSelector';
import { IChipSelectorProps } from '../ChipSelector/types';

export const ChipSelectorControlled = <T extends FieldValues, IOption extends IOptionType>(
  props: UseControllerProps<T> & Omit<IChipSelectorProps<IOption>, 'selected' | 'onChange'>,
) => {
  const { name, control, rules, defaultValue, ...restProps } = props;

  const { field, fieldState } = useController({
    name,
    control,
    rules,
    defaultValue,
  });

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { ref, value, ...restField } = field;
  const { error } = fieldState;

  return <ChipSelector fieldError={error} selected={value} {...restField} {...restProps} />;
};
